import {motion} from "framer-motion";
import {useContext, useState} from "react";
import EventContext from '/context/EventContext.js';
import {SvgEventTicketmb, VectorTailDown} from "/components/shared/SvgIcons";
import GoldButton from "/components/shared/buttons/GoldButton";
import {useRouter} from "next/router";
import DetailsNavigationMobile from "/components/shared/navigation/DetailsNavigationMobile";
import AboutTheaterNavigationMobile from "/components/shared/navigation/AboutTheaterNavigationMobile";

export default function MobileViewHeader() {
    let layoutId = null;
    let imageLayoutId = null;
    const router = useRouter();
    const {event} = useContext(EventContext);
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className='p-1 xl:p-4'>
          <div>
            <h1 className='text-md text-black-medium font-cooper truncate'>
              {(event || {}).title}
            </h1>
            <div className='flex justify-center items-center w-full'>
              <GoldButton onClick={() => router.push('#tickets')}
                          icon={<div className="pb-1 mr-2">{SvgEventTicketmb()}</div>}
                          style='rounded-full px-3 pt-1 text-sm sm:text-base mt-8 mr-1'>
                Tickets kaufen
              </GoldButton>

              <GoldButton onClick={() => router.push(`/ticket-validation/${event.slug}`)}
                          icon={<div className="pb-1 mr-2">{SvgEventTicketmb()}</div>}
                          style='rounded-full px-3 pt-1 text-sm sm:text-base mt-8'>
                Code einlösen
              </GoldButton>
            </div>
            <div className='flex flex-col h-12 items-center my-2 border-t-[1px] border-black'>
              <button onClick={() => setIsOpen(!isOpen)}>
                <div className='flex flex-col items-center'>
                  <h4 className='text-gold text-sm sm:text-md pt-2 uppercase'>Menu
                    Anzeigen</h4>
                  <div className='pb-6'>
                    {isOpen ?
                     <div
                       className='rotate-x-180'>{VectorTailDown()}</div> : VectorTailDown()}
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
    );
}
